import { useEffect } from "react";

const NotFound = () => {
  useEffect(() => {
    window.location.replace("/404.html");
  }, []);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        fontSize: "2rem",
      }}
    >
      페이지를 찾을 수 없습니다.
    </div>
  );
};

export default NotFound;
